import { Module } from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { IApprovalRequestsState } from "../types";
import { StoreState } from "@/store/type";

const approvalRequestsModule: Module<IApprovalRequestsState, StoreState> = {
  state,
  getters,
  mutations,
  actions,
};

export default approvalRequestsModule;
